import { chunk, uniq } from "lodash";
import { ChannelkartNetworkGet, ChannelkartNetworkPost } from "./networkService";
import { NotificationProductFilter } from "../components/NotificationAdditionalComponents/NotificationAdditionalComponents";
import { ProductMetaDataSkuDetails } from "../features/notification/notificationTypes";
import { defaultNotificationOptions } from "../features/notification/notificationRegistry";


export async function getUserList(designation : string, immediateParent?:string[], channel?: string[], outletClass?: string[], immediateRole?:string){
    try {
        let url = `/users?size=10000&filter=userContext[notnull]:true and designation:${designation}` + ((immediateParent && immediateParent.length) ? (" and hierarchy[regex][exact]:" + immediateParent[0]) : "");
        if(designation === "retailer"){
            url = `/v1/query/retailerFilterData?&designation="${( immediateRole ?? "")}"&channel="${(channel ? channel.join('","') : '')}"&name="${(immediateParent?.length ? immediateParent.join('","') : "")}"&outletClass="${(outletClass ? outletClass.join('","') : '')}"`
        }
        const response = await ChannelkartNetworkGet(url)
        response.data.features.forEach((feature:any)=>{
            feature.id = feature.id ?? feature.loginId;
        })
        return response;
    } catch (error) {
        console.log(error)
    }
}

export async function getImmediateParent(designation : string){
    try {
        const response = await ChannelkartNetworkGet(`/users?size=10000&filter=designation:${designation} and hierarchy[regex][exact]:${JSON.parse(localStorage.authContext).user.loginId}`)
        return response;
    } catch (error) {
        
    }
}

export async function triggerNotification(finalArray: any[]){
    await ChannelkartNetworkPost("/v1/smart-triggers/default-firebase-notification-trigger/start",finalArray);
    return 0;
}

export async function sendNotificationData(finalArray: any[]){
    let response = await ChannelkartNetworkPost("/notification/v1/send",finalArray);
    return response.data.features;
}

export async function fetchNotificationRedirectionOptions(){
    const url = '/metadata/clientconfig';
    try{
        const response = await ChannelkartNetworkGet(url);
        const config = response.data.features.find((Obj: { domainType: string }) => {
            return Obj.domainType === 'config'
        })
        return config.domainValues?.[0]?.notificationHeaderOptions ?? defaultNotificationOptions;
    }catch(err){
        console.log(err);
        return defaultNotificationOptions;
    }
}
export async function getAvailableSkuOptions():Promise<string[]>{
    try{
        const response:{data:{features:ProductMetaDataSkuDetails[]}} = await ChannelkartNetworkGet("/v1/query/productMetadata_sku_details");
        const options = response.data.features.map(data=>data.sku_description + " - " + data.batch_code)
        return options;
    }catch(error){
        return [];
    }

}

export async function getNotificationProductFilterData(productFilterData:NotificationProductFilter[],selectedFilterOptions:{[key:string]:string[]}){

    const updatedProductFilterData:Promise<NotificationProductFilter>[] = productFilterData.map(async(filterObject)=>{
        let filter:string = "";
        Object.keys(selectedFilterOptions).forEach(key=>{
            if(key!==filterObject.key && selectedFilterOptions[key].length){
                filter =  (filter ? filter + " and " : "?filter=") + key + "[in]:[" + selectedFilterOptions[key] + ']'
            }
        })
        const url = "/v1/distinctFieldData/productDetails/" +  filterObject.key + filter;
        try{
            const response = await ChannelkartNetworkGet(url.replaceAll("&","%26"));
            const options = response.data.map((filterResponse:any)=>filterResponse[filterObject.key]);
            const filteredOptions = options.filter((option: any) => option !== null && option !== "NA");
            return {...filterObject, options:filteredOptions}
            // return {...filterObject, options}
        }catch(error){
            console.log(error);
            return {...filterObject, options:[]};
        }
    });
    return Promise.all(updatedProductFilterData);
}


export async function sendNotificationInChunks(finalArray: any[]) {
    let failureCount= 0;
    if (finalArray.length > 0) {
        let splitArray = chunk(finalArray, 100);
        for (let usersBatchIdx = 0; usersBatchIdx < splitArray.length; usersBatchIdx++) {
            try{
                const response = await sendNotificationData(splitArray[usersBatchIdx]);
                response.forEach((value: any) => {
                    if (value.status === "fail") {
                        failureCount += 1;
                    }
                });
            }catch(error){
                failureCount += 100;
            }
            
        }
    }
    return failureCount;
}

export async function getDistinctFieldData(tableName:string,field:string){
    const response = await ChannelkartNetworkGet(`/v1/distinctFieldData/${tableName}/${field}`);
    return response.data.map((data:any)=>data[field]).filter(Boolean);
}
export async function fetchHistoryTableData(pageNum: number,searchField?: string, searchConfig?: string[]){
    if(searchField && searchConfig){
        const filterParams = searchConfig.reduce((prevValue,elem,index) => {
            if(index===searchConfig.length-1)
            return prevValue +=elem + "[regex]:" + searchField + " AND ";
    
            return prevValue +=elem + "[regex]:" + searchField + " OR ";
        },"")
        const url = `/v1/notifications/histories?page=${pageNum}&size=10&filter=${filterParams}type:firebase&sort=creationTime:desc&source=portal&callType=scheduled`;
        try{
            const response = await ChannelkartNetworkGet(url);
            return response.data;
        }catch(err){
            console.log(err);
            return {
                currentPage: 0,
                totalPage: 0,
                totalElements: 0,
                features: []
            };
        }
    }else{
        const url = `/v1/notifications/histories?page=${pageNum}&size=10&filter=type:firebase&sort=creationTime:desc&source=portal&callType=scheduled`;
    try{
        const response = await ChannelkartNetworkGet(url);
        return response.data;
    }catch(err){
        console.log(err);
        return {
            currentPage: 0,
            totalPage: 0,
            totalElements: 0,
            features: []
        };
    }
    }
}
